import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
  styleUrls: ['./timeout-dialog.component.scss'],
})
export class TimeoutDialogComponent implements OnInit, OnDestroy {
  //showing 2 minute early timer before logout to avoid any on going api failier
  public timerWatch = environment.session_timeout_warning_in_seconds - environment.session_logout_early_in_seconds; // converted in seconds
  public minute = (environment.session_timeout_warning_in_seconds - environment.session_logout_early_in_seconds) / 60 - 1; // to start watch from {minute}:59; one less minute
  private timerClockSub?: Subscription;
  public seconds = 60;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<TimeoutDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.timerClockSub = interval(1000).subscribe((el) => {
      if (this.seconds == 0) {
        this.minute--;
        this.seconds = 60;
      }
      this.timerWatch--;
      this.seconds--;

      if (this.timerWatch == 0) {
        this.dialogRef.close(false);
      }
    });
  }

  onStay() {
    this.dialogRef.close(true); // User wants to stay
  }

  ngOnDestroy(): void {
    this.timerClockSub?.unsubscribe();
  }
}
